import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { organizationRoute } from './organization-routes';

export const settingsRoute = createRoute({
  getParentRoute: () => organizationRoute,
  path: '/settings',
  component: lazyRouteComponent(
    () => import('@/modules/settings/SettingsLayout'),
    'SettingsLayout',
  ),
});

const parent = () => settingsRoute;

/** Settings of the organization, one route per section, each loaded when it is opened. */
export const settingsPages = [
  createRoute({
    getParentRoute: parent,
    path: '/',
    component: lazyRouteComponent(() => import('@/modules/settings/roles/RolesPage'), 'RolesPage'),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/users',
    component: lazyRouteComponent(() => import('@/modules/settings/users/UsersPage'), 'UsersPage'),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/organization',
    component: lazyRouteComponent(
      () => import('@/modules/settings/OrganizationPage'),
      'OrganizationPage',
    ),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/places',
    component: lazyRouteComponent(
      () => import('@/modules/settings/places/PlacesPage'),
      'PlacesPage',
    ),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/modules',
    component: lazyRouteComponent(
      () => import('@/modules/settings/modules/ModulesPage'),
      'ModulesPage',
    ),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/states',
    component: lazyRouteComponent(() => import('@/modules/settings/StatesPage'), 'StatesPage'),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/privacy',
    component: lazyRouteComponent(
      () => import('@/modules/settings/privacy/PrivacyPage'),
      'PrivacyPage',
    ),
  }),
  createRoute({
    getParentRoute: parent,
    path: '/security',
    component: lazyRouteComponent(
      () => import('@/modules/settings/security/SecurityPage'),
      'SecurityPage',
    ),
  }),
] as const;
